import { ExportOptions, ExportResult } from './types';
import { generateKdpPdf, generateLeadMagnetPdf } from './pdf';
import { generateDocx } from './docx';
import { generateEpub } from './epub';

export async function exportBook(options: ExportOptions): Promise<ExportResult> {
  const { format, book } = options;

  switch (format) {
    case 'kdp-epub':
      return generateEpub(book);
    case 'kdp-pdf':
      return generateKdpPdf(book);
    case 'lead-magnet-pdf':
      return generateLeadMagnetPdf(book);
    case 'docx':
      return generateDocx(book);
    default:
      throw new Error(`Unsupported export format: ${format}`);
  }
}

export function downloadExport(result: ExportResult) {
  const url = URL.createObjectURL(result.blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = result.filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}